export const StatsActions = {
    SET_STATS_ENABLED: 'Stats.SET_STATS_ENABLED',
    SET_MEAN_FPS: 'Stats.SET_MEAN_FPS',
    SET_FPS_METER_ENABLED: 'SET_FPS_METER_ENABLED',
}
